import React, { useState, useEffect } from "react";
import { useTheme } from "../../hooks/useTheme";

const RefreshIndicator = ({ onComplete }) => {
  const { theme } = useTheme();
  const [isVisible, setIsVisible] = useState(true);

  const isDarkMode = theme === "dark";
  const bgColor = "var(--bg)";
  const accentColor = "var(--accent)";

  useEffect(() => {
    // Set body background color to match theme
    document.body.style.backgroundColor = bgColor;
    document.documentElement.style.backgroundColor = bgColor;

    // Fade out after 0.7 seconds, then call onComplete
    const fadeTimer = setTimeout(() => {
      setIsVisible(false);
    }, 700);

    const completeTimer = setTimeout(() => {
      onComplete();
    }, 1000); // 0.7s + 0.3s fade out

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete, bgColor]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: bgColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        opacity: isVisible ? 1 : 0,
        transition: "opacity 0.3s ease-out",
      }}
    >
      {/* Refresh Icon */}
      <div
        style={{
          animation: "refreshRotate 1s ease-in-out forwards",
        }}
      >
        <svg
          width="60"
          height="60"
          viewBox="0 0 24 24"
          fill="none"
          stroke={accentColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            filter: isDarkMode
              ? `drop-shadow(0 0 12px ${accentColor}60) drop-shadow(0 0 24px ${accentColor}30)`
              : `drop-shadow(0 0 16px ${accentColor}80) drop-shadow(0 0 32px ${accentColor}50)`,
            animation: "glowPulse 1s ease-in-out",
          }}
        >
          <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
        </svg>
      </div>

      <style>
        {`
          @keyframes refreshRotate {
            0% {
              transform: rotate(0deg);
              opacity: 0;
            }
            20% {
              opacity: 1;
            }
            80% {
              opacity: 1;
            }
            100% {
              transform: rotate(360deg);
              opacity: 1;
            }
          }

          @keyframes glowPulse {
            0%, 100% {
              opacity: 0.8;
            }
            50% {
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

export default RefreshIndicator;
